// extracted by mini-css-extract-plugin
export default {"page":"TY-z","cartModal":"UY-z","checkout":"VY-z","placeholder":"WY-z","account":"XY-z"};